import { createStore } from 'vuex';  
  
export default createStore({  
    state: {  
        num: null, 
        activeId: null,
        foodtype: null,
    },  
    mutations: {  
        // 更新 activeId 的值  
        setActiveId(state, primaryKey) {  
            state.activeId = primaryKey;  
        },  
        incrementNum(state) {  
            state.num = (state.num || 0) + 1; 
        },  
        setFoodType(state, foodType) {
            state.foodtype = foodType;  
        }, 
    },  
    actions: {  
        updateActiveId({ commit }, item) {  
            commit('setActiveId', item['主键']); // 使用 item 的主键来更新 state.activeId  
        },  
    },  
    modules: {},  
    getters: {  
        count: (state) => state.num,  
        activeId: (state) => state.activeId, // 添加一个 getter 来获取 activeId  
        foodtype: (state) => state.foodtype,
    },  
});